import vm from "@/main";

async function getTheme() {
  console.log("主---------------------")
  var _this=this
  var styleTheme = localStorage.getItem("m-style");
  console.log(styleTheme)
  console.log("主---------------------")
  var theme = "";
  var bgPageTheme = "";
  var contentPageTheme = "";
  var changeHeaderKuangPageTheme = "";
  //if (styleTheme==null||styleTheme==undefined||styleTheme+""===""|| styleTheme + "" === "1") {
    localStorage.setItem("m-style","1");
    console.log("主题一i")
    theme = "#409EFF";
    bgPageTheme = "#202020";
    contentPageTheme = "#121212";
    changeHeaderKuangPageTheme = "#2d2d2d";
  await vm.$changeBgPageTheme(bgPageTheme);
  await vm.$changeContentPageTheme(contentPageTheme);
    _this.$store.dispatch("Theme/changeStyleTheme", styleTheme);
    document.getElementsByClassName("sidebar-container").forEach((item) => {
      item.style = "background-color:" + bgPageTheme + ";";
    });
    document.getElementsByClassName("main-container").forEach((item) => {
      item.style = "background-color:" + bgPageTheme + ";";
    });

    if (document.getElementsByClassName("searchForm-maomao")) {
      document.getElementsByClassName("searchForm-maomao").forEach((item) => {
        item.style = "background-color:" + contentPageTheme + ";";
      });
    }
    if (document.getElementsByClassName("searchForm-maomao-cw")) {
      document
        .getElementsByClassName("searchForm-maomao-cw")
        .forEach((item) => {
          item.style = "background-color:" + contentPageTheme + ";";
        });
    }
    if (document.getElementsByClassName("table_maomao")) {
      document.getElementsByClassName("table_maomao").forEach((item) => {
        item.style = "background-color:" + contentPageTheme + ";";
      });
    }

    // 获取所有具有类名'asd'的元素
    var elements = document.getElementsByClassName("el-scrollbar__view");

    // 遍历这些元素，找到第一个并检查其第一个子元素是否为<ul>
    for (var i = 0; i < elements.length; i++) {
      var firstChild = elements[i].firstElementChild; // 获取第一个子元素
      if (firstChild && firstChild.tagName === "UL") {
        // 检查是否为<ul>
        firstChild.style.backgroundColor = contentPageTheme; // 设置样式
        break; // 找到后退出循环
      }
    }

    const divs = document.getElementsByClassName("searchForm-maomao-cw");
    for (let div of divs) {
      // 找到每个div下的所有input元素
      const inputs = div.getElementsByTagName("input");
      for (let input of inputs) {
        input.style.backgroundColor = changeHeaderKuangPageTheme; // 修改样式
        input.style.border = "1px solid " + changeHeaderKuangPageTheme + ";";
      }
    }
    const divs1 = document.getElementsByClassName("searchForm-maomao");
    for (let div of divs1) {
      // 找到每个div下的所有input元素
      const inputs = div.getElementsByTagName("input");
      for (let input of inputs) {
        input.style.backgroundColor = changeHeaderKuangPageTheme; // 修改样式
        input.style.border = "1px solid " + changeHeaderKuangPageTheme + ";";
      }
    }
  //}
}
export default {
  getTheme,
};
